import { useState, useRef } from "react";
import { IoChevronDown } from "react-icons/io5";
import { cn } from "helper/Utils";

const CustomYearAndMonthSelect = ({ options, value, onChange, defaultValue, btnClassName }) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);

  // Toggle dropdown visibility
  const toggleDropdown = () => setIsOpen(!isOpen);

  // Handle option selection
  const handleOptionSelect = (selectedValue) => {
    onChange(selectedValue);
    setIsOpen(false);
  };

  return (
    <div className="relative w-full" onMouseDown={(e) => e.stopPropagation()}>
      {/* Dropdown button */}
      <button
        type="button"
        ref={buttonRef}
        onClick={toggleDropdown}
        className={cn(
          "relative flex items-center justify-between w-full rounded bg-white/15 text-white/80 text-sm py-1.5 px-3 text-[12px]",
          "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white/25",
          btnClassName
        )}
      >
        {value ? value : defaultValue ? defaultValue : ""}
        <IoChevronDown className="pointer-events-none size-4 absolute right-1 fill-white/60" aria-hidden="true" />
      </button>

      {/* Dropdown options */}
      {isOpen && (
        <ul className="absolute z-[1001] mt-1 max-h-40 w-full overflow-auto rounded-xl bg-body border border-white/5 shadow-lg p-1 focus:outline-none">
          {options.length > 0 ? (
            options.map((option) => (
              <li
                key={option.value}
                onClick={() => handleOptionSelect(option)}
                className={cn(
                  "text-white/60 bg-white/10 text-[12px] px-3 py-1.5 my-[1px] rounded select-none",
                  "cursor-pointer hover:bg-white/20 hover:text-white",
                  value === option ? "bg-white/20 text-white" : ""
                )}
              >
                {option}
              </li>
            ))
          ) : (
            <li className="text-sm text-white py-2 px-3">No results found</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default CustomYearAndMonthSelect;
